import { render, staticRenderFns } from "./BulkNocDocuments.vue?vue&type=template&id=1b384949"
import script from "./BulkNocDocuments.vue?vue&type=script&lang=js"
export * from "./BulkNocDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports